__turbopack_context__.v({
  "active": "channelCard-module-scss-module__Os_SEG__active",
  "albumContainerDesktop": "channelCard-module-scss-module__Os_SEG__albumContainerDesktop",
  "albumContainerMobile": "channelCard-module-scss-module__Os_SEG__albumContainerMobile",
  "albumCover": "channelCard-module-scss-module__Os_SEG__albumCover",
  "albumImage": "channelCard-module-scss-module__Os_SEG__albumImage",
  "albumWrapper": "channelCard-module-scss-module__Os_SEG__albumWrapper",
  "allowTextSquash": "channelCard-module-scss-module__Os_SEG__allowTextSquash",
  "borderBackground": "channelCard-module-scss-module__Os_SEG__borderBackground",
  "button": "channelCard-module-scss-module__Os_SEG__button",
  "channelCard": "channelCard-module-scss-module__Os_SEG__channelCard",
  "colorBorder": "channelCard-module-scss-module__Os_SEG__colorBorder",
  "contentWrapper": "channelCard-module-scss-module__Os_SEG__contentWrapper",
  "desktopColorBorder": "channelCard-module-scss-module__Os_SEG__desktopColorBorder",
  "disableShadow": "channelCard-module-scss-module__Os_SEG__disableShadow",
  "kabab": "channelCard-module-scss-module__Os_SEG__kabab",
  "listenLiveText": "channelCard-module-scss-module__Os_SEG__listenLiveText",
  "playIcon": "channelCard-module-scss-module__Os_SEG__playIcon",
  "radioImage": "channelCard-module-scss-module__Os_SEG__radioImage",
  "radioImageBackground": "channelCard-module-scss-module__Os_SEG__radioImageBackground",
  "radioImageLink": "channelCard-module-scss-module__Os_SEG__radioImageLink",
  "radioInfoContainer": "channelCard-module-scss-module__Os_SEG__radioInfoContainer",
  "radioTextInfo": "channelCard-module-scss-module__Os_SEG__radioTextInfo",
  "shadow": "channelCard-module-scss-module__Os_SEG__shadow",
});
